import { VermietetesObjekt } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectVermieteteObjekte = (state: IAppState): VermietetesObjekt[] =>
  state.vermieteteObjekte;
